import clsx from 'clsx';
import MutedText from 'components/common/MutedText';
import { PlateEditor } from 'components/editor/plate-editor';
import { HubertButton } from 'components/HubertUI/HubertButton';
import { format } from 'date-fns';
import { ExternalLink } from 'lucide-react';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { Notification } from 'types/notification.types';
import { useNotifications } from '../notifications.context';

interface Props extends ComponentProps<'div'> {
  notification: Notification;
}

const NotificationsItem = ({ notification, ...props }: Props) => {
  const { t } = useTranslation('Notifications');
  const { popOverisOpen, setPopOverIsOpen, markNotificationAsRead, isMarkNotificationAsReadRequestLoading } =
    useNotifications();
  const url = notification.url;

  const onMarkReadClick = (closePopover: boolean) => {
    if (!notification.isRead) {
      markNotificationAsRead(notification);
      // refetchNotifications();
    }
    if (closePopover) {
      setPopOverIsOpen(!popOverisOpen);
    }
  };

  return (
    <div
      {...props}
      className={clsx(
        'flex flex-col justify-between gap-2',
        'w-full',
        'rounded-md border border-gray-100 p-4',
        'hover:bg-gray-50',
      )}
    >
      <div className={clsx('flex flex-row justify-between gap-2', 'hubert-vertical-center')}>
        <div>{notification.actor.name ?? t('item.unknownUser')}</div>
        <div className={clsx('flex flex-row justify-between gap-2', 'hubert-vertical-center')}>
          <HubertButton
            size={'sm'}
            variant={'info'}
            loading={isMarkNotificationAsReadRequestLoading}
            onClick={() => {
              onMarkReadClick(false);
            }}
            className={`${notification.isRead ? 'hidden' : ''}`}
          >
            {t('item.markAsRead')}
          </HubertButton>

          {url?.value ? (
            <Link to={url?.value} target={url?.target}>
              <HubertButton
                icon={<ExternalLink />}
                size={'sm'}
                variant={'ghost'}
                onClick={() => {
                  onMarkReadClick(true);
                }}
              />
            </Link>
          ) : null}
        </div>
      </div>
      <div className={clsx('border-s-2 px-2')}>
        <PlateEditor
          isReadOnly={true}
          value={notification.content.value?.length ? notification.content.value : notification.content.html}
        />
      </div>
      <div className={clsx('flex justify-end')}>
        <MutedText text={`${format(new Date(notification.createdAt), 'PPp')}`} />
      </div>
    </div>
  );
};

export default NotificationsItem;
